import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import EnvBanner from './components/EnvBanner.jsx';
import './index.css';

const savedTheme = localStorage.getItem('hg_theme') || 'auto';
if (savedTheme === 'light') document.documentElement.classList.add('light');
else if (savedTheme === 'dark') document.documentElement.classList.add('dark');

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <EnvBanner />
    <App />
  </StrictMode>,
);
